// Padlock used on the "reporting period is closed" banners (Timesheet and the
// Approvals week view). Decorative — always paired with the banner text, so it is
// aria-hidden. Fixed 16px with the inline offset both banners were drawn with.
export function LockIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      style={{ flexShrink: 0, marginTop: 1 }}
    >
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  );
}
